import styled from '@emotion/styled';
import { Select } from '@mui/material';

export const UserItemContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0px;
`;

export const StyledSelect = styled(Select)`
  .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  .MuiSelect-select {
    padding-right: 32px;
  }

  &.MuiOutlinedInput-root {
    box-shadow: none;
  }

  &:hover .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border: none;
  }
`;
